import moment from "moment";

export type Period = "today" | "week" | "month" | "custom";

export interface ApiDateRange {
  start_date: string;
  end_date: string;
}

// Matches the shape of react-day-picker's DateRange without importing from it directly
export interface PickerDateRange {
  from: Date | undefined;
  to?: Date | undefined;
}

export const PERIOD_LABELS: Record<Period, string> = {
  today: "Today",
  week: "This Week",
  month: "This Month",
  custom: "Custom Range",
};

const HOURS_IN_DAY = 24;
const HOURS_IN_WEEK = 24 * 7;
const HOURS_IN_30_DAYS = 24 * 30;

export const getPeriodDateRange = (
  period: Period,
  customRange?: PickerDateRange
): ApiDateRange => {
  const now = moment();
  const today = now.format("YYYY-MM-DD");
  switch (period) {
    case "today":
      return {
        start_date: now.clone().subtract(HOURS_IN_DAY, "hours").format("YYYY-MM-DD"),
        end_date: today,
      };
    case "week":
      return {
        start_date: now.clone().subtract(HOURS_IN_WEEK, "hours").format("YYYY-MM-DD"),
        end_date: today,
      };
    case "month":
      return {
        start_date: now.clone().subtract(HOURS_IN_30_DAYS, "hours").format("YYYY-MM-DD"),
        end_date: today,
      };
    case "custom":
      if (customRange?.from) {
        return {
          start_date: moment(customRange.from).format("YYYY-MM-DD"),
          end_date: customRange.to
            ? moment(customRange.to).format("YYYY-MM-DD")
            : moment(customRange.from).format("YYYY-MM-DD"),
        };
      }
      return {
        start_date: now.clone().subtract(HOURS_IN_30_DAYS, "hours").format("YYYY-MM-DD"),
        end_date: today,
      };
    default:
      return {
        start_date: now.clone().subtract(HOURS_IN_30_DAYS, "hours").format("YYYY-MM-DD"),
        end_date: today,
      };
  }
};
